import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "fullImgSrc"];
import React from 'react';
import { useMobileOS } from '@beef/react';
import { AutoMetricBlockType, AutoMetricElement } from '@beef/auto-metric';
import { OS } from "./types";
import { APPLE_STORE_ID, DEFAULT_APP_BLOCK } from "../../constants";
import { StoreLink } from "../StoreLink";
import { AppleFullLink, AppleLink } from "../AppleLink";
export var StoreLinkList = function StoreLinkList() {
  var os = useMobileOS();
  var renderStoreLink = function renderStoreLink(_ref) {
    var id = _ref.id,
      fullImgSrc = _ref.fullImgSrc,
      props = _objectWithoutProperties(_ref, _excluded);
    switch (os) {
      case OS.IOS:
        return id === APPLE_STORE_ID ? /*#__PURE__*/React.createElement(AppleFullLink, _extends({}, props, {
          imgSrc: fullImgSrc,
          "data-t-id": "components-StoreLinkList"
        })) : null;
      case OS.Android:
        return id === APPLE_STORE_ID ? null : /*#__PURE__*/React.createElement(StoreLink, props);
      default:
        return id === APPLE_STORE_ID ? /*#__PURE__*/React.createElement(AppleLink, props) : /*#__PURE__*/React.createElement(StoreLink, props);
    }
  };
  return DEFAULT_APP_BLOCK.store.links.map(function (storeLink) {
    var storeLinkElement = renderStoreLink(storeLink);
    return storeLinkElement ? /*#__PURE__*/React.createElement(AutoMetricElement, {
      key: storeLink.id,
      params: {
        name: 'StoreLink',
        id: storeLink.id
      },
      type: AutoMetricBlockType.ELEMENT
    }, storeLinkElement) : null;
  });
};